import React, { useState, useContext } from 'react';
import { CurpContext } from '../context/CurpContext';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import Logo from '../components/Logo';
import BackgroundLayout from '../components/BackgroundLayout';
import Label from '../components/form/Label';
import { toast } from 'react-hot-toast';

const SelfTest = () => {
    const textClass = "text-base font-bold mt-10 mb-10 text-justify text-gray-800 drop-shadow-sm uppercase"
    const navigate = useNavigate();
    // Solo se escribe: los errores se muestran con toast, no desde el estado.
    const [, setErrors] = useState({});
    const { curp } = useContext(CurpContext);
    const buttonsContainer = "flex w-full space-x-4 mt-5 mb-5"
    const inputClass = "border p-2 rounded-md w-full drop-shadow-md mt-5";
    const [selectedWillAttendButton, setSelectedWillAttendButton] = useState(null);
    const [showInputAddress, setShowAddressInput] = useState(null);

    const handleButtonClick = (name, value) => {
        if (name === 'will_attend_community_center') {
            setShowAddressInput(value);
            setSelectedWillAttendButton(value);
            setFormData({ ...formData, [name]: value });
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value })
    };

    const [formData, setFormData] = useState({
        curp: curp,
        address: '',
        will_attend_community_center: false,
        month_income_quantity: '',
    });

    const validateForm = () => {
        let formErrors = {};
        if (formData.will_attend_community_center && !formData.address) {
            formErrors.address = 'La dirección es obligatoria si cubres los gastos de envío.';
        }
        setErrors(formErrors);
        return Object.keys(formErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) {
            toast.error('Ingresa una dirección 🙄');
            return;
        }
        try {
            const response = await fetch('https://admin-django-inspira.azurewebsites.net/api/services/register-self-test/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });
            if (response.ok) {
                toast.success('Revisaremos tu información y te contactamos pronto');
                navigate('/thank-you'); // Redirige a una página de éxito
            } else {
                toast.error('Ay, algo pasó, intenta nuevamente.');
            }
        } catch (error) {
            console.error('Error:', error);
            toast.error('Error en la conexión, intenta nuevamente.');
        }
    };

    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.3, // Aumenta el tiempo entre la aparición de cada hijo
            },
        },
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 20 },
        visible: {
            opacity: 2,
            y: 0,
            transition: {
                duration: 1, // Aumenta la duración de la animación
                ease: "easeInOut", // Suaviza la animación
            },
        },
        exit: {
            opacity: 0,
            y: 20,
            transition: {
                duration: 1, // Aumenta la duración de la animación de salida
                ease: "easeInOut", // Suaviza la animación de salida
            },
        },
    };

    return (
        <BackgroundLayout className="px-8 pb-24">
            <motion.div
                className="w-full text-left mt-0 lg:w-2/3 lg:mb-10"
                variants={containerVariants}
                initial="hidden"
                animate="visible"
            >
                <Logo />
                <motion.h1 initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1, delay: 0.5 }} className='text-center text-7xl font-bold text-[#f8485e] mt-10 mb-2 drop-shadow-sm'>🦸🏼‍♀️</motion.h1>
                <motion.h1 initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1, delay: 0.5 }} className='text-5xl font-bold text-[#f8485e] mt-2 mb-10 drop-shadow-md uppercase'>Activa tus superpoderes</motion.h1>
                <motion.h1 variants={itemVariants} className="text-base text-justify font-bold mt-5 mb-2 text-gray-800 uppercase drop-shadow-sm">La auto prueba de ITS en casa ofrece la confidencialidad de realizarla en la privacidad del hogar, la comodidad de no tener que acudir a un centro de salud, la rapidez de obtener resultados en pocos minutos, la accesibilidad para quienes tienen dificultades para acceder a servicios tradicionales, y el empoderamiento de tomar decisiones informadas sobre la salud sexual</motion.h1>
                <motion.h1 initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 1, delay: 0.5 }} className='text-center text-7xl font-bold text-[#f8485e] mt-5 mb-2 drop-shadow-sm'>🫣</motion.h1>
                <form onSubmit={handleSubmit}>
                    <motion.div variants={containerVariants} className="mb-4 mt-5">
                        <motion.div className="mb-4" variants={itemVariants}>
                            <label className={textClass}>¿Cuál es tu ingreso mensual aproximado?</label>
                            <Label text='Sabemos que esta pregunta puede sentirse incómoda... pero es necesaria. 
                            Por lineamientos, necesitamos este dato para poder continuar. 
                            Nos sirve para saber si podemos apoyarte con algunos servicios, como la auto prueba. Gracias por confiar 💖' />
                            <select
                                name="month_income_quantity"
                                value={formData.month_income_quantity}
                                onChange={handleChange}
                                className={inputClass}
                                required
                            >
                                <option value="">Selecciona</option>
                                <option value="ingreso_1">Menos de $5,300</option>
                                <option value="ingreso_2">Entre $5,300 y $10,500</option>
                                <option value="ingreso_3">Entre $10,500 y $15,800</option>
                                <option value="ingreso_4">Entre $15,800 y $21,000</option>
                                <option value="ingreso_5">Más de $21,000</option>
                            </select>
                        </motion.div>
                        <label className={textClass}>¿Te has hecho una prueba de VIH?</label>
                        <div className={buttonsContainer}>
                            <motion.div variants={itemVariants} className='w-1/2 flex justify-center'>
                                <button
                                    variants={itemVariants}
                                    type="button"
                                    onClick={() => handleButtonClick('hiv_tested', true)}
                                    className={`w-full rounded-md border-2 drop-shadow-md p-4 m-2 text-sm font-bold uppercase transition-all ${formData.hiv_tested ? 'bg-inspiraPink text-white border-inspiraPink' : 'bg-white text-inspiraPink border-inspiraPink'}`}
                                >
                                    Sí, ya me he hecho la prueba antes
                                </button>
                            </motion.div>
                            <motion.div variants={itemVariants} className='w-1/2 flex justify-center'>
                                <button
                                    variants={itemVariants}
                                    type="button"
                                    onClick={() => handleButtonClick('hiv_tested', false)}
                                    className={`w-full rounded-md border-2 drop-shadow-md p-4 m-2 text-sm font-bold uppercase transition-all ${formData.hiv_tested === false ? 'bg-inspiraPink text-white border-inspiraPink' : 'bg-white text-inspiraPink border-inspiraPink'}`}
                                >
                                    No, nunca me he hecho la prueba
                                </button>
                            </motion.div>
                        </div>
                        <label className={textClass}>Folio de Autoprueba</label>
                        <Label text='Ingresa el folio de tu Autoprueba (AP)' />
                        <input
                            type="text"
                            name="selftest_folio"
                            value={formData.selftest_folio}
                            onChange={handleChange}
                            className={inputClass}
                        />


                        <Label text='¿Cómo prefieres recibir el material para tu auto prueba?' />
                        <motion.div className={buttonsContainer} variants={containerVariants}>
                            <div className='w-1/2 flex justify-center'>
                                <motion.button
                                    variants={itemVariants}
                                    type="button"
                                    onClick={() => handleButtonClick('will_attend_community_center', true)}
                                    className={`rounded-md border-2 drop-shadow-md p-2 m-2 ${selectedWillAttendButton === true ? 'bg-inspiraPink text-white border-inspiraPink' : 'bg-inspiraSoftPink text-inspiraPink border-inspiraPink'}`}
                                    required
                                >
                                    Puedo cubrir los gastos de envío 🤑 📦
                                </motion.button>
                            </div>
                            <div className='w-1/2 flex justify-center'>
                                <motion.button
                                    variants={itemVariants}
                                    type="button"
                                    onClick={() => handleButtonClick('will_attend_community_center', false)}
                                    className={`w-full rounded-md border-2 drop-shadow-md p-4 m-2 text-xs font-bold uppercase transition-all ${selectedWillAttendButton === false ? 'bg-inspiraPink text-white border-inspiraPink' : 'bg-white text-inspiraPink border-inspiraPink'}`}
                                    required
                                >
                                    Asistiré al centro comunitario a recoger el material 🏃🏾‍♀️
                                </motion.button>
                            </div>
                        </motion.div>
                    </motion.div>
                    {showInputAddress && (
                        <motion.div variants={containerVariants}>
                            <Label text='¿Dónde se encuentra tu castillo? (Es decir, ¿cuál es tu dirección?)' />
                            <motion.input
                                variants={itemVariants}
                                name="address"
                                value={formData.address}
                                onChange={handleChange}
                                className={inputClass}
                                placeholder='Calle y número | Código Postal | Colonia | Municipio'
                            />
                        </motion.div>
                    )}
                    <motion.div variants={itemVariants} className='w-full flex justify-center'>
                        <button type="submit" className="bg-[#f8485e] hover:bg-[#d93a4f] text-white mt-10 mb-24 p-4 rounded-xl shadow-lg w-1/2 text-lg font-bold uppercase transition-all active:scale-95">
                            Enviar
                        </button>
                    </motion.div>
                </form>
            </motion.div>
        </BackgroundLayout>
    );
};

export default SelfTest;